import React from 'react';
import { Select } from '@ts/storybook';

type TPositionGenerationPolicyId =
  | 'BLEStrongest'
  | 'BLETrilateration'
  | 'BLEFingerPrinting'
  | 'WiFiStrongest'
  | 'WiFiTrilateration'
  | 'WiFiFingerPrinting'
  | 'externalEngine';

type TBaseOption = {
  label: string;
  value: TPositionGenerationPolicyId;
  disabled: boolean;
};

type TDevicePGP = {
  positionGenerationPolicyId: TPositionGenerationPolicyId;
};

type SelectOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

const PGPs: ReadonlyArray<TBaseOption> = [
  { label: 'BLE, strongest', value: 'BLEStrongest', disabled: true },
  { label: 'BLE, trilateration', value: 'BLETrilateration', disabled: true },
  { label: 'BLE, finger printing', value: 'BLEFingerPrinting', disabled: true },
  { label: 'Wi-Fi, strongest', value: 'WiFiStrongest', disabled: true },
  { label: 'Wi-Fi, trilateration', value: 'WiFiTrilateration', disabled: true },
  { label: 'Wi-Fi, finger printing', value: 'WiFiFingerPrinting', disabled: true },
  { label: 'External engine', value: 'externalEngine', disabled: true },
] as const;

function generatePGPs(pgps?: TDevicePGP[] | null): TBaseOption[] {
  // Start with everything disabled (do NOT mutate the constant PGPs array)
  const enabled = new Set<TPositionGenerationPolicyId>(Array.isArray(pgps) ? pgps.map(p => p.positionGenerationPolicyId) : []);

  return PGPs.map(opt => ({
    ...opt,
    disabled: !enabled.has(opt.value),
  }));
}

export interface IPositionGenerationPoliciesSelectorProps {
  positionGenerationPolicies?: TDevicePGP[] | null;
  value: TPositionGenerationPolicyId | ''; // "" => None
  disabled?: boolean;
  onChange: (value: TPositionGenerationPolicyId | '') => void;
}

const PositionGenerationPoliciesSelector: React.FC<IPositionGenerationPoliciesSelectorProps> = props => {
  const options = generatePGPs(props.positionGenerationPolicies);

  const selectOptions: SelectOption[] = [
    { value: '', label: 'None' },
    ...options.map(o => ({ value: o.value, label: o.label, disabled: o.disabled })),
  ];

  return (
    <Select
      label="Position generation policy"
      value={props.value}
      onChange={props.onChange as any}
      disabled={props.disabled}
      options={selectOptions}
    />
  );
};

export default PositionGenerationPoliciesSelector;
